import { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as St5LogoWhite } from '../assets/st5_white.svg';

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const headerRef = useRef<HTMLElement>(null);
  const location = useLocation();

  // Close when navigating to a new route
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // Close on Escape key
  useEffect(() => {
    if (!menuOpen) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMenuOpen(false);
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [menuOpen]);

  // Close when clicking outside the header
  useEffect(() => {
    if (!menuOpen) return;
    const onOutsideClick = (e: MouseEvent) => {
      if (headerRef.current && !headerRef.current.contains(e.target as Node)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', onOutsideClick);
    return () => document.removeEventListener('mousedown', onOutsideClick);
  }, [menuOpen]);

  return (
    <header className="global-header" ref={headerRef}>
      <div className="header-inner">
        <Link to="/" className="header-logo" aria-label="Smart Transform 5.0 – Startseite">
          <St5LogoWhite role="img" aria-label="Smart Transform 5.0" />
        </Link>

        <button
          className={`hamburger${menuOpen ? ' is-open' : ''}`}
          onClick={() => setMenuOpen((o) => !o)}
          aria-label={menuOpen ? 'Menü schließen' : 'Menü öffnen'}
          aria-expanded={menuOpen}
        >
          <span />
          <span />
          <span />
        </button>

        <nav className={`header-nav${menuOpen ? ' is-open' : ''}`}>
          <Link to="/">Start</Link>
          <Link to="/events">Events</Link>
          <Link to="/presse">Presse</Link>
          <Link to="/kontakt">Kontakt</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
